import { Instance } from 'mobx-state-tree';
import { AnchorStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';

import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Anchor } from '../../../store/models/Anchor';

interface AnchorFormFieldProps extends WithTranslateProps {
  AnchorStore?: Instance<typeof AnchorStore>;
  anchorList?: Array<Instance<typeof Anchor>>;
  onAnchorIdChanged?: (anchorId: number | undefined) => void;
  anchorId?: number | undefined;
}

@inject('AnchorStore')
@observer
class AnchorFormField extends React.Component<AnchorFormFieldProps> {
  renderAnchorMenuItem(item: Instance<typeof Anchor>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`anchor-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.name}
        />
      );
    } else {
      return null;
    }
  }

  filterAnchor = (query, anchor) => {
    return (anchor.name).toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { AnchorStore, ...otherProps } = this.props;
    let { anchorList } = this.props;
    if (anchorList == null) {
      anchorList = AnchorStore.dataList;
    }

    return (
      <>
        <SelectInputFormField
          label={TLCode.ANCHOR_Color}
          name="anchorId"
          inline={true}
          items={toJS(anchorList)}
          itemValueGetter={(item: { anchorId: number; name: string; }) => item.anchorId}
          valueItemGetter={(value) => AnchorStore.getById(value)}
          inputValueRenderer={(item) => (item != null ? item.name: '')}
          itemRenderer={this.renderAnchorMenuItem}
          itemPredicate={this.filterAnchor}
          identifier={'anchorId'}
          elementLabel={'name'}
          labelSelectAnElement={this.props.translate(TLCode.CHOOSE_AN_ANCHOR)}
          helperText={this.props.translate(TLCode.CHOOSE_AN_ANCHOR)}
          placeholderSelection={TLCode.CHOOSE_AN_ANCHOR}
          afterItemSelected={otherProps.onAnchorIdChanged}
          {...otherProps}
        />
      </>
    );
  }
}

export default withTranslate(AnchorFormField);
